import React, { memo } from 'react';
import { SvgIcon, SvgIconProps, Theme, useTheme } from '@mui/material';

interface Props extends SvgIconProps {
  alt?: boolean;
  dark?: boolean;
}

function ReferralsIcon({ dark = false, ...rest }: Props) {
  const { palette }: Theme = useTheme();
  const foreground = dark ? palette.secondary.lightest : palette.primary.dark;

  return (
    <SvgIcon viewBox="0 0 24 24" {...rest}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M11.4614 3.45089C10.7293 2.18278 10.0043 3.5402 9.96984 4.31225C9.76032 6.53873 8.2512 8.91569 6 10.8479L8.84592 15.777C11.645 14.7933 14.4576 14.6754 16.4909 15.6071C17.2004 16.049 18.6838 15.9602 17.9827 14.7458L11.4614 3.45089Z"
          fill={foreground}
        />
        <path
          d="M5.17371 11.6738L2.61651 13.1505C1.19235 13.9728 0.803549 15.4241 1.62579 16.8482L1.71819 17.0081C2.54019 18.4325 3.99171 18.8213 5.41563 17.9988L7.97307 16.5223L5.17371 11.6738Z"
          fill={foreground}
        />
        <path
          d="M8.0862 17.4512L5.66724 18.8477L8.40012 21.6545C8.97395 22.2437 9.72516 22.2536 10.3141 21.68C10.9033 21.1064 10.9134 20.3549 10.3396 19.7657L8.0862 17.4512Z"
          fill={foreground}
        />
        <rect x="16.3" y="7" width="5" height="1" rx="0.5" transform="rotate(-30 16.3 7)" fill={foreground} />
        <rect x="13.8" y="3.6001" width="3" height="1" rx="0.5" transform="rotate(-60 13.8 3.6001)" fill={foreground} />
        <rect x="18.79" y="11.5264" width="3" height="1" rx="0.5" fill={foreground} />
      </g>
    </SvgIcon>
  );
}

export default memo(ReferralsIcon);
